module.exports = __webpack_public_path__ + "img/menu__icon.2415e46f.svg";